/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const GSTATIC_URL = 'https://www.gstatic.com/recaptcha/releases';

/**
 * Removes the Google reCAPTCHA container element.
 *
 * @return {void} This function does not return a value.
 */
export function removeRecaptchaScript() {
    (window as any).___grecaptcha_cfg = undefined;

    const recaptchaScript = document.querySelector(
        'script[src*="/recaptcha/"]:not([src*="gstatic"])'
    );

    if (recaptchaScript) {
        recaptchaScript.remove();
    }

    const gStaticScript = document.querySelector(`script[src^="${GSTATIC_URL}"]`);

    if (gStaticScript) {
        gStaticScript.remove();
    }
}

// cSpell:ignore gstatic
